import { MenuItem, StandardEntity } from '@infodata-group/inf-commons';

export class Product extends StandardEntity {
  public children: Product[] = [];

  constructor(id: string, label: string) {
    super();
    this.id = id;
    this.label = label;
  }

  toMenuItem(): MenuItem {
    const item = new MenuItem(
      this.id,
      `${this.label[0].toUpperCase()}${this.label.slice(1)}`,
      '',
      '',
    );

    this.children.length === 0
      ? (item.route = `changelogs/${this.id}`)
      : this.children.forEach((product) => {
          item.submenus.push(
            new MenuItem(
              product.id,
              product.label,
              '',
              `changelogs/${encodeURIComponent(product.id)}`, // pour gérer les routes contenant des caractères spéciaux
            ),
          );
        });

    return item;
  }
}
